import Vue from 'vue'
import App from './App.vue'
import store from './store'
import 'classlist-polyfill'
import browserDetect from 'vue-browser-detect-plugin'

Vue.config.productionTip = false

Vue.use(browserDetect)

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
